/* eslint-disable @next/next/no-img-element */
import React from 'react'
import { Header2, Text } from '../../styles/Components'
import Image from 'next/image'
import BeautyImage from '../../../public/how-it-works/GS_how_it_works_true_beauty.jpeg'

const TrueBeauty = () => {
  return (
    <div className="section-wrapper true-beauty">
      <div className="web-container">
        <div className="left">
          <div className="title-container">
            <Header2 lineHeight="140%">
              Glamsquad was built by a team of beauty pros, entrepreneurs +
              engineers.
            </Header2>
          </div>
          <div className="text-container">
            <Text lineHeight="145%" fontSize={24} margin="0 0 24px 0">
              We believe salon-quality, at-home glam services should be
              accessible to everyone. That&apos;s why we provide inside access
              to the best of beauty — with pro services for every skin tone,
              hair type, and glam style.
            </Text>
            <Text lineHeight="145%" fontSize={24}>
              The best part? We can be at your doorstep in as little as two
              hours to get you ready for just about anything. This is beauty
              where, when, and exactly how you want it.
            </Text>
          </div>
          <img
            className="script-image"
            src="/how-it-works/script.svg"
            alt="script-logo-true-beauty"
          />
        </div>
        <div className="image-placeholder">
          <Image
            src={BeautyImage}
            alt='true beauty'
            style={{ objectFit: 'cover' }}
            fill
          />
        </div>
      </div>
      <div className="mobile-container">
        <Header2 lineHeight="140%" margin="0 0 34px 0">
          Glamsquad was built by a team of beauty pros, entrepreneurs +
          engineers.
        </Header2>
        <div className="mobile-image-container">
          <div className="mobile-left">
            <img
              className="mobile-script-image"
              src="/how-it-works/script.svg"
              alt="script-logo-true-beauty"
            />
          </div>
          <div className="mobile-right">
            <Image
              src={BeautyImage}
              alt='true beauty'
              style={{ objectFit: 'cover' }}
              fill
              priority
            />
          </div>
        </div>
        <Text lineHeight="145%" fontSize={24} margin="0 0 18px 0">
          We believe salon-quality, at-home glam services should be accessible
          to everyone. That&apos;s why we provide inside access to the best of
          beauty — with pro services for every skin tone, hair type, and glam
          style.
        </Text>
        <Text lineHeight="145%" fontSize={24}>
          The best part? We can be at your doorstep in as little as two hours to
          get you ready for just about anything. This is beauty where, when, and
          exactly how you want it.
        </Text>
      </div>
    </div>
  )
}

export default TrueBeauty
